<template>
  <div>
    <div class="pa-3"><h1>Dine-In Store Management</h1></div>
    <v-card class="elevation-0" style="border: 1px solid black">
      <v-card-title>
        <v-layout wrap>
          <v-flex xs12 sm8 class="pa-1">
            <v-text-field
              prepend-icon="search"
              label="Enter your keyword"
              placeholder="Store name, Store Tel."
              v-model="search"
            ></v-text-field
          ></v-flex>
          <v-flex xs12 sm4 class="pa-1"
            ><v-select
              :items="provinceData"
              item-text="province_name_th"
              item-value="province_id"
              label="Filter by province"
              clearable
              v-model="filterByProvinceId"
            ></v-select>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :loading="is_loading_store"
        :items="filteredStoreList"
        :rows-per-page-items="[20, 50, 100, 200]"
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-center">{{ props.index + 1 }}</td>
          <td>
            <v-switch
              v-model="props.item.store_status"
              color="primary"
              @change="changeState(props.item)"
              hide-details
            ></v-switch>
          </td>
          <td class="text-xs-center">
            {{ getProvinceName(props.item.store_province) || "-" }}
          </td>
          <td class="text-xs-center">
            {{ props.item.store_name_th }}
          </td>
          <td class="text-xs-center">
            {{ props.item.store_name_en }}
          </td>
          <td class="text-xs-center">
            {{ props.item.store_tel }}
          </td>
          <!-- <td class="text-xs-center">
          {{ moment(props.item.update_at).format("MMMM Do YYYY, HH:mm:ss") }}
        </td> -->
          <td class="text-xs-center">
            <v-btn
              :to="`/weserve_admin_login/-/maindinein/storemanage/${props.item.store_id}/${props.item.store_name_th}/productlist`"
              icon
              class="view-detail-btn"
              style="background-color: #fddf00"
            >
              <v-icon style="font-size: 18px; color: black"
                >mdi-food-drumstick</v-icon
              >
            </v-btn>
            <v-btn
              icon
              class="view-detail-btn"
              @click="
                openEditDineInStore(
                  props.item.store_id,
                  props.item.store_name_en
                )
              "
            >
              <v-icon style="font-size: 18px; color: white">edit</v-icon>
            </v-btn>
            <v-btn
              :to="`/weserve_admin_login/-/maindinein/storemanage/${props.item.store_id}/${props.item.store_name_th}/special-close`"
              icon
              class="view-detail-btn"
              style="background-color: #fddf00"
            >
              <v-icon style="font-size: 18px; color: black"
                >mdi-timer-cog</v-icon
              >
            </v-btn>
            <v-btn
              icon
              class="edit-time-btn"
              @click="
                openEditDineInStoreTime(
                  props.item.store_id,
                  props.item.store_name_en
                )
              "
            >
              <v-icon style="font-size: 18px; color: white">alarm</v-icon>
            </v-btn>
            <v-btn
              icon
              class="delete-btn"
              @click="openDeleteStore(props.item.store_id)"
            >
              <v-icon style="font-size: 18px; color: white">delete</v-icon>
            </v-btn>
          </td>
        </template>

        <template slot="no-data">
          <div v-if="is_loading_store == true" class="text-xs-center">
            <v-progress-circular
              :size="30"
              color="primary"
              indeterminate
            ></v-progress-circular>
            Loading data ...
          </div>
          <div v-else class="text-xs-center">No data available</div>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog
      v-model="edit_store_dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="black">
          <v-toolbar-title>
            <div style="color: white">
              {{ edit_store_name.toUpperCase() }}
            </div>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon dark @click="edit_store_dialog = false">
              <v-icon color="white">close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <EditStore
          :store_id="edit_store_id"
          @closeEditDialog="watchEditDialog"
          :dialog="edit_store_dialog"
        ></EditStore>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="edit_store_time_dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>
            <div style="color: black">
              {{ edit_time_name.toUpperCase() }}
            </div>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon dark @click="edit_store_time_dialog = false">
              <v-icon color="black">close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <EditStoreTime
          :store_time_id="edit_time_id"
          @closeEditDialog="watchEditTimeDialog"
        ></EditStoreTime>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteDialog" max-width="500px">
      <v-card>
        <v-card-title class="headline yellow lighten-2" primary-title>
          Delete Store
        </v-card-title>

        <v-card-text style="font-size: 1.35rem; margin-block: 15px">
          Are you sure to permanent delete this store?
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" flat @click="deleteDialog = false"> Cancel </v-btn>
          <v-btn color="primary" flat @click="deleteStore"> Confirm </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="error_dialog" max-width="500px">
      <v-card>
        <v-card-title class="headline yellow lighten-2" primary-title>
          Delete Failed
        </v-card-title>

        <v-card-text style="font-size: 1.35rem; margin-block: 15px">
          Your deletion failed with some problems. Please try again.
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" flat @click="error_dialog = false"> Cancel </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import moment from "moment";
import EditStore from "../../../../components/back-office/DineIn/Store/EditStore.vue";
import EditStoreTime from "../../../../components/back-office/DineIn/Store/EditStoreTime.vue";
export default {
  data: () => ({
    search: "",
    filterByProvinceId: null,
    detail_dialog: false,
    selected_item: {},
    dialog: false,
    change: 0,
    edit_store_dialog: false,
    edit_store_time_dialog: false,
    is_loading_store: false,
    deleteDialog: false,
    error_dialog: false,
    edit_store_id: 0,
    edit_store_name: "",
    edit_time_name: "",
    edit_time_id: 0,
    testData: "",
    disable_popular: false,
    store_name_th: null,
    delete_id: "",

    headers: [
      {
        text: "No.",
        align: "center",
        sortable: false,
      },
      {
        text: "Status",
        align: "center",
        value: "store_status",
        sortable: false,
      },
      {
        text: "Province",
        align: "center",
        value: "store_province",
        sortable: false,
      },
      {
        text: "Store name TH",
        align: "center",
        value: "store_name_th",
        sortable: false,
      },
      {
        text: "Store Name EN",
        align: "center",
        value: "store_name_en",
        sortable: false,
      },
      {
        text: "Store Tel.",
        align: "center",
        value: "store_tel",
        sortable: false,
      },
      {
        text: "Action",
        align: "center",
        value: "",
        sortable: false,
      },
    ],
  }),
  components: { EditStore, EditStoreTime },
  computed: {
    ...mapState({
      dinein_store_list: (state) => state.fetchDineIn.store_list,
      provinceData: (state) => state.fetchProvinceBack.provinceData,
    }),
    ...mapGetters(["isEditStoreApprove"]),

    filteredStoreList() {
      console.log(this.dinein_store_list);
      return this.dinein_store_list.filter(
        (val) =>
          (!this.filterByProvinceId ||
            this.filterByProvinceId == val.store_province) &&
          val.store_name_th.toLowerCase().includes(this.search.toLowerCase())
      );
    },
  },
  watch: {
    store_list: {
      handler: function () {
        let count = 0;
        for (let val of this.store_list) {
          if (val.store_popular == true) {
            count++;
          }
        }
        if (count >= 5) {
          this.disable_popular = true;
        } else {
          this.disable_popular = false;
        }
      },
      deep: true,
      change: function () {},
    },
  },

  created() {
    this.fetchData();
  },
  methods: {
    moment,
    openEditDineInStore(id, name) {
      this.edit_store_id = id;
      this.edit_store_name = name;
      this.edit_store_dialog = true;
    },
    openEditDineInStoreTime(id, name) {
      this.edit_time_id = id;
      this.edit_time_name = name;
      this.edit_store_time_dialog = true;
    },
    openDeleteStore(index) {
      this.delete_id = index;
      this.deleteDialog = true;
    },
    toDetailStore(item) {
      this.selected_item = item;
      this.detail_dialog = true;
    },
    watchEditDialog() {
      this.edit_store_dialog = false;
      this.change++;
    },
    watchEditTimeDialog() {
      this.edit_store_time_dialog = false;
      this.change++;
    },
    async deleteStore() {
      var res = await this.$store.dispatch(
        "fetchDineIn/deleteDineInStore",
        this.delete_id
      );
      if (res == true) {
        this.deleteDialog = false;
        const stores = this.dinein_store_list.filter(
          (obj) => obj.store_id !== this.delete_id
        );
        this.$store.dispatch("fetchDineIn/updateStoreList", stores);
      } else {
        this.deleteDialog = false;
        this.error_dialog = true;
      }
    },
    async changeState(item) {
      var payload = {
        data: {
          store_id: item.store_id,
          store_types: item.store_types.map((val) => val.store_type_id),
          store_categories: item.store_categories.map(
            (val) => val.store_category_id
          ),
          delete_image_id: [],
          store_package: item.store_package,
          store_name_th: item.store_name_th,
          store_name_en: item.store_name_en,
          store_address_th: item.store_address_th,
          store_address_en: item.store_address_en,
          store_description_th: item.store_description_th,
          store_description_en: item.store_description_en,
          store_recommend: item.store_recommend,
          store_best_seller: item.store_best_seller,
          store_district: item.store_district,
          store_sub_district: item.store_sub_district,
          store_zipcode: item.store_zipcode,
          store_lat: item.store_lat,
          store_long: item.store_long,
          store_image: item.storeImageList || [],
          store_profile: item.store_profile,
          store_province: item.store_province,
          store_tel: item.store_tel,
          store_rating: item.store_rating,
          store_email: item.store_email,
          store_approve: item.store_approve,
          store_status: item.store_status,
          store_commission: item.store_commission,
          store_table_amount: item.store_table_amount,
          store_period_table_time: item.store_period_table_time,
        },
      };
      var res = await this.$store.dispatch(
        "fetchDineIn/updateDineInStore",
        payload
      );
      if (res === false) {
        item.store_status = !item.store_status;
      }
    },
    getProvinceName(id) {
      let isFound = "";
      for (let i = 0; i < this.provinceData.length; i++) {
        if (this.provinceData[i].province_id == id) {
          isFound = this.provinceData[i].province_name_en;
        }
      }
      if (isFound != "") {
        return isFound;
      } else {
        return null;
      }
    },
    async fetchData() {
      this.is_loading_store = true;
      await this.$store.dispatch("fetchProvinceBack/getData");
      await this.$store.dispatch("fetchDineIn/getAllDineInStore", {
        page_size: 9999999999,
        current_page: 1,
      });
      this.is_loading_store = false;
    },
  },
};
</script>

<style scoped>
.popular_toggle {
  position: absolute;
  top: 13px;
  left: 40%;
}

.view-detail-btn {
  font-size: 13px;
  outline: none;
  background-color: #2196f3;
  padding: 5px;
  border-radius: 20px;
  color: white;
  margin: 5px;
  margin-right: 10px;
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.19);
}

.edit-time-btn {
  font-size: 13px;
  outline: none;
  background-color: #2175f3;
  padding: 5px;
  border-radius: 20px;
  color: white;
  margin: 5px;
  margin-right: 10px;
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.19);
}

.delete-btn {
  font-size: 13px;
  outline: none;
  background-color: red;
  padding: 5px;
  border-radius: 20px;
  color: white;
  margin: 5px;
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.19);
}

.view-detail-btn span {
  outline: none;
}
</style>
